import { PayloadAction } from '@reduxjs/toolkit';

import { createHcReduxSlice } from '@hcs/utils';

import { MarketStateSliceState, MarketStatsSearchValue } from '../types';

const initialState: MarketStateSliceState = {
  msaSearch: null,
  zipSearch: null,
};

export const marketStateSearchSlice = createHcReduxSlice({
  name: 'marketStateSearch',
  initialState,
  reducers: {
    updateMsaSearch: (state, action: PayloadAction<MarketStatsSearchValue>) => {
      state.msaSearch = action.payload;
    },
    updateZipSearch: (state, action: PayloadAction<MarketStatsSearchValue>) => {
      state.zipSearch = action.payload;
    },
  },
});
